import apiFetch from '../apiFetch'

export default function () {
  return apiFetch({endPoint: `TeclaContaje`, method: 'GET', body: null})
}
